import React from 'react';
import img from './duration.png';
import {Link} from "@reach/router";
import AppRouters from "../../../../../../settings/app-routers";
import clsx from "clsx";

import styles from './info.module.scss';

export const InfoSlideItem = () => {
    return (
        <div className={clsx("h-full w-full flex-center flex-d-center gap-8", styles.container)}>
            <img src={img} alt="duration" height="200px" className="pr-8"/>
            <div className="flex flex-col text-center flex-center">
                <h3 className="pb-4">¿Deseas comprar un auto usado?</h3>
                <div className={styles.infoContainer}>
                    <span>Asegura tu inversión verificando la información del vehículo.</span>
                    <span>Te daremos todos los datos que necesitas con rapidez.</span>
                </div>
                <div className={clsx("flex gap-4 flex-center pt-4", styles.actionsContainer)}>
                    <Link to={AppRouters.myReports} className="btn btn-outline-primary form-control">
                        <span>Mis Reportes</span>
                    </Link>
                    <Link to={AppRouters.newReport} className="btn btn-primary form-control">
                        <span>Solicitar Reportes</span>
                    </Link>
                </div>
            </div>
        </div>
    );
};
